var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-topTool"},[_vm._t("left"),_vm._v(" "),(_vm.centerDefault)?_c('countDown',{staticStyle:{"height":"72px"},attrs:{"title":_vm.title,"className":"device"}}):_c('countDownRow',{attrs:{"title":_vm.title}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }